import { Constants } from './constants';

/**
 * UKC show types that support a show-level "Junior Price" (and optional
 * "Early Bird Junior Price"), applied to any junior handler's dog classes
 * within that show. Shared by the Price tab UI, the show save payload, and
 * the entry-fee calculation logic so the three stay in sync.
 */
export const UKC_JUNIOR_FEE_SHOW_TYPES: string[] = [
  Constants.show_type.rally_obedience,
  Constants.show_type.obedience,
  Constants.show_type.weight_pull,
  Constants.show_type.dock_jumping,
  Constants.show_type.precision_coursing,
  Constants.show_type.nosework,
];
